import { Fragment, useEffect, useState, useMemo, useCallback } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import DateRangePicker from "react-bootstrap-daterangepicker";
import {
    getProductSuggests
} from "actions/productActions";
import { ReactTable, ReactTableDataGrid } from "components/Table";
import { ListDateType } from "helper/constant";
import { formatterCreateAt, convertTZ, subStringText, countString } from "components/Function";
import SelectBox from "components/elements/selectBox";
import Loading from "components/Loading";
import Swal from "sweetalert2";
import ReactImageMagnify from "react-image-magnify";


const ProductList = ({
    getProductSuggests,
    productSuggest,
    formatterCreateAt,
    countString,
}) => {
    const [page, setPage] = useState(1);
    const [sizePerPage, setSizePerPage] = useState(50);
    const [searchText, setSearchText] = useState("");
    const [totalSize, setTotalSize] = useState(0);
    const [dateType, setDateType] = useState("");
    const [products_selected, setProductsSelected] = useState([]);
    const [filter, setFilter] = useState({});
    const [staffs, setStaffs] = useState([]);
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(false);
    const [productScheduleSelect, setProductScheduleSelect] = useState(null);
    // const [rowShow, setRowShow] = useState("");
    const { t } = useTranslation();
    const { list, totalsize, isLoading } = productSuggest;

    const sizePerPageList = [
        {
            text: "10",
            value: 10,
        },
        {
            text: "50",
            value: 50,
        },
        {
            text: "100",
            value: 100,
        },
        {
            text: "150",
            value: 150,
        },
        {
            text: "200",
            value: 200,
        },
        {
            text: "All",
            value: totalsize || 50,
        },
    ];

    useEffect(() => {
        if (Object.keys(filter).length) {
            getProductSuggests({ page, sizeperpage: sizePerPage, search: searchText, filter });
        }
    }, [getProductSuggests, page, sizePerPage, searchText, filter]);

    useEffect(() => {
        setTotalSize(totalsize);
    }, [totalsize]);

    useEffect(() => {
        setPage(1);
        setSizePerPage(50);

        if (dateType === "") {
            setFilter((prev) => ({
                ...prev,
                dateStart: "",
                dateEnd: "",
            }));
        }
        if (dateType === "custom") {
            let date_start = new Date();
            date_start = convertTZ(date_start);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date();
            date_end = convertTZ(date_end);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "today") {
            let date_start = new Date();
            date_start = convertTZ(date_start);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date();
            date_end = convertTZ(date_end);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "yesterday") {
            let date_start = new Date();
            date_start = convertTZ(date_start);
            date_start.setDate(date_start.getDate() - 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date_start);
            date_end.setDate(date_end.getDate());
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "this_week") {
            let date_start = new Date();
            date_start = convertTZ(date_start);
            date_start.setDate(date_start.getDate() - date_start.getDay() + 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date_start);
            date_end.setDate(date_end.getDate() + 6);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "last_week") {
            let date_start = new Date();
            date_start = convertTZ(date_start);
            date_start.setDate(date_start.getDate() - 7 - date_start.getDay() + 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date_start);
            date_end.setDate(date_end.getDate() + 6);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "this_month") {
            let date = new Date();
            date = convertTZ(date);
            let date_start = new Date(date.getFullYear(), date.getMonth(), 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "last_month") {
            let date = new Date();
            date = convertTZ(date);
            date.setMonth(date.getMonth() - 1);
            let date_start = new Date(date.getFullYear(), date.getMonth(), 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "this_year") {
            let date = new Date();
            date = convertTZ(date);
            let date_start = new Date(date.getFullYear(), 0, 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date.getFullYear(), 11, 31);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "last_year") {
            let date = new Date();
            date = convertTZ(date);
            date.setFullYear(date.getFullYear() - 1);
            let date_start = new Date(date.getFullYear(), 0, 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date.getFullYear(), 11, 31);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        // eslint-disable-next-line
    }, [dateType]);

    // const handleSchedule = (id) => {
    //     setRowShow(id)
    //     console.log(rowShow)
    //     Swal.fire(t("Success"), id, "success");

    // };

    const columns = [
        {
            field: 'checkbox',
            headerName: "",
            cellClass: "centered-cell",
            headerCheckboxSelection: true,
            checkboxSelection: true,
            width: 50,
        },
        {
            field: "_id",
            headerName: "",
            sort: true,
            editable: false,
            cellClass: "centered-cell",
            width: 10,
            cellRenderer: ({ rowIndex, value: cell, data: row }) => rowIndex + 1,
        },
        {
            field: "image",
            headerName: "Image",
            cellClass: "centered-cell overflow-visible",
            sort: true,
            editable: false,
            cellRenderer: ({ data: row, value: cell }) => (
                <>
                    <div className="symbol symbol-50px">
                        <Link to={cell} target="_blank"><ReactImageMagnify
                            {...{
                                smallImage: {
                                    alt: "",
                                    width: 50,
                                    height: 50,
                                    src: cell || require("components/assets/media/misc/image.png"),
                                },
                                largeImage: {
                                    src: cell || require("components/assets/media/misc/image.png"),
                                    width: 600,
                                    height: 600,
                                },
                                enlargedImageContainerDimensions: { width: "600%", height: "600%" },
                                enlargedImageContainerStyle: { zIndex: 999999 },
                                className: "cursor-pointer",
                                enlargedImageContainerClassName: "al-zoom-img-cus",
                                imageStyle: { zIndex: 9999999 },
                            }}
                        /></Link>

                    </div>
                </>
            ),
        },
        {
            field: "title",
            headerName: t("Title"),
            editable: false,
            sort: true,
            // flex: 1,            
        },
        {
            field: "count",
            headerName: t("Total Sold"),
            editable: false,
            sort: true,
            // flex: 1,            
        },
        {
            field: "create_time",
            headerName: t("Created At"),
            editable: false,
            sort: true,
            cellRenderer: ({ value: cell }) => <span data-tooltip-id="my-tooltip"
                data-tooltip-content={formatterCreateAt(+cell * 1000)}>{formatterCreateAt(+cell * 1000)}</span>,
        },
    ];

    const handleTableChange = (type, { page, sizePerPage, searchText }) => {
        if (type === "search") {
            setPage(1);
            setSizePerPage(50);
            setSearchText(searchText);
        } else {
            setPage(page);
            setSizePerPage(sizePerPage);
        }
    };

    const handleFilter = (e) => {
        setFilter((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const handleEventDate = (start, end) => {
        setPage(1);
        setSizePerPage(50);

        let date_start = new Date(start);
        date_start.setHours(0, 0, 0, 0);

        let date_end = new Date(end);
        date_end.setHours(23, 59, 59, 999);
        setFilter((prev) => ({
            ...prev,
            dateStart: date_start.getTime(),
            dateEnd: date_end.getTime(),
        }));
    };

    const onSelectionChanged = (data) => {
        if (data.api) {
            const ids = data.api.getSelectedRows().map((d) => d._id);
            setProductsSelected(ids);
        }
    };

    // const removeSelect = (arr, value) => {
    //     var i = 0;
    //     while (i < arr.length) {
    //         if (arr[i] === value) {
    //             arr.splice(i, 1);
    //         } else {
    //             ++i;
    //         }
    //     }
    //     return arr;
    // };

    // const onSelect = (row, isSelect) => {
    //     var products_selected_tmp = products_selected;
    //     if (isSelect) {
    //         products_selected_tmp.push(row._id);
    //     } else {
    //         products_selected_tmp = removeSelect(products_selected_tmp, row._id);
    //     }
    //     var new_arr = JSON.stringify(products_selected_tmp);
    //     setProductsSelected(JSON.parse(new_arr));
    // };

    // const onSelectAll = (isSelect, row) => {
    //     var products_selected_tmp = products_selected;
    //     if (isSelect) {
    //         products_selected_tmp = row.map((v, i) => v._id);
    //     } else {
    //         products_selected_tmp = [];
    //     }
    //     setProductsSelected(products_selected_tmp);
    // };

    // const handleTableSaveCell = (oldValue, newValue, row, column) => {
    //     saveEditProduct({
    //         _id: row._id,
    //         [column.dataField]: newValue,
    //         page,
    //         sizeperpage: sizePerPage,
    //         search: searchText,
    //         filter,
    //     });
    // };

    const onCellValueChanged = ({ data, colDef, newValue, oldValue }) => {
        if (newValue !== oldValue) {
            // saveEditProduct({
            //     _id: data._id,
            //     [colDef.field]: newValue,
            //     page,
            //     sizeperpage: sizePerPage,
            //     search: searchText,
            //     filter,
            // });
        }
    }

    const groupButton = () => {
        return (
            <>
                <div className="mb-5">
                    <Select
                        name="dateType"
                        options={ListDateType}
                        className="basic-multi-select al-custom-select-search-variants mr-1 mb-0 al-filter-table me-2"
                        classNamePrefix="select"
                        value={ListDateType.filter(({ value }) => value === dateType)}
                        onChange={(e) => {
                            setDateType(e?.value || "");
                        }}
                        placeholder="Select a date ... "
                    />
                    {dateType === "custom" && filter?.dateStart && filter?.dateEnd ? (
                        <DateRangePicker
                            onCallback={handleEventDate}
                            initialSettings={{
                                startDate: formatterCreateAt(filter.dateStart, "dmy"),
                                endDate: formatterCreateAt(filter.dateEnd, "dmy"),
                                showDropdowns: true,
                                locale: { format: "DD/MM/YYYY" },
                            }}
                        >
                            <input type="text" className="form-control al-form-control-daterangepicker mr-1" />
                        </DateRangePicker>
                    ) : (
                        ""
                    )}
                </div>
            </>
        );
    };

    const onTableChanged = ({ page, limit, text }) => {
        if (limit) setSizePerPage(limit);
        if (page) setPage(page);
        if (typeof text === "string") setSearchText(text);
    };

    const onFirstDataRendered = (params) => {
        params.columnApi.autoSizeColumns(["main_image", "title", "product_sku", "categories", "msg", "createdBy", "created_at", "-"]);
    };

    return (
        <div className="card min-w-full">
            <Loading isLoading={isLoading || loading} />
            <div className="card-body">
                <div className="al-variants-table al-max-height-table-cus">
                    {/* <ReactTable
                        columns={columns}
                        data={list || []}
                        groupButton={groupButton}
                        handleTableChange={handleTableChange}
                        page={page}
                        sizePerPage={sizePerPage}
                        totalSize={totalSize}
                        alClassName="table-layout-inherit"
                        sizePerPageList={sizePerPageList}
                        isSelectRow={true}
                        selectRow={selectRow}
                        handleBeforeSaveCell={handleTableSaveCell}
                        isCellEdit={true}
                    /> */}
                    <ReactTableDataGrid
                        tableName="productSystem"
                        idProperty="image"
                        columns={columns}
                        rowData={list}
                        gridOptions={{
                            rowHeight: 80,
                            reactiveCustomComponents: true,
                        }}
                        paginationPageSize={sizePerPage}
                        totalSize={totalSize}
                        onTableChanged={onTableChanged}
                        emptyText={t("No data!")}
                        rowSelection="multiple"
                        onSelectionChanged={onSelectionChanged}
                        sizePerPageList={sizePerPageList}
                        onCellValueChanged={onCellValueChanged}
                        onFirstDataRendered={onFirstDataRendered}
                        groupButton={groupButton}
                    />
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = ({ productSuggest }) => ({ productSuggest });
const mapDispatchToProps = {
    getProductSuggests,
    formatterCreateAt,
    subStringText,
    countString,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductList);
